import React from "react";
import { RadioButtonProps } from "../../types/screensTypes";
import { Tooltip } from "@mui/material";
import Icon from "./Icon";
import styles from "./RadioButton.module.css";

export interface RadioButtonStyleClasses {
    dot?: string;
    dotOn?: string;
    label?: string;
}

const RadioButton: React.FC<RadioButtonProps & { classes?: RadioButtonStyleClasses }> = ({
    label,
    subtitle,
    checked,
    onChange,
    activeImage: _activeImage,
    inactiveImage: _inactiveImage,
    center = false,
    textSize = "normal",
    disabled = false,
    tooltip,
    classes = {},
}) => {
    const wrapperClass = [
        center ? `${styles.center} radio-button-center` : `${styles.root} radio-button`,
        disabled ? "radio-disabled" : "",
    ]
        .filter(Boolean)
        .join(" ");

    const handleClick = () => {
        if (!disabled) {
            onChange();
        }
    };

    const dot = (
        <div
            className={[
                classes.dot ?? `${styles.dot} radio-dot`,
                checked ? (classes.dotOn ?? `${styles.dotOn} radio-dot--on`) : "",
                disabled ? `${styles.dotDisabled} radio-dot--disabled` : "",
            ]
                .filter(Boolean)
                .join(" ")}
            role="presentation"
        >
            <Icon name="ic-check" className={`ic ${styles.dotCheck} radio-dot__check`} />
        </div>
    );

    return (
        <div
            className={wrapperClass}
            data-rw-control="radio"
            onClick={handleClick}
            role="radio"
            aria-checked={checked}
            aria-disabled={disabled || undefined}
            style={{ cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : undefined }}
        >
            <input
                type="radio"
                checked={checked}
                onChange={handleClick}
                disabled={disabled}
                className={`${styles.input} ${styles.hiddenInput} radio-input hidden-radio`}
            />
            {tooltip ? <Tooltip title={tooltip}>{dot}</Tooltip> : dot}

            <div className={`${styles.text} radio-text`}>
                {textSize === "normal" ? (
                    <h3 className={classes.label ?? `${styles.label} radio-label`}>{label}</h3>
                ) : (
                    <p className={classes.label ?? `${styles.label} radio-label`}>{label}</p>
                )}
                {subtitle && <p>{subtitle}</p>}
            </div>
        </div>
    );
};

export default RadioButton;
